import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { users as getUsers } from "reduxSlices/formSubmissionSlice"
import { makeSection } from "utils/formDataHelpers"
import { questionShape, taskShape } from "utils/propTypeShapes"
import { AnsweredFormOverview } from "shared/form"

const TaskCompletedGeneralTask = ({ generalTaskQuestion, task, taskControls }) => {
  const { answers } = task
  const users = useSelector(getUsers, isEqual)
  const generalTaskSections = [makeSection({ questions: [generalTaskQuestion] })]

  return (
    <AnsweredFormOverview
      answers={answers}
      className="w-full"
      postSectionsContent={taskControls}
      sections={generalTaskSections}
      users={users}
    />
  )
}

TaskCompletedGeneralTask.propTypes = {
  generalTaskQuestion: questionShape.isRequired,
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskCompletedGeneralTask
